import { render, staticRenderFns } from "./DeductionModal.vue?vue&type=template&id=2de1f01e&scoped=true&"
import script from "./DeductionModal.vue?vue&type=script&lang=js&"
export * from "./DeductionModal.vue?vue&type=script&lang=js&"
import style0 from "./DeductionModal.vue?vue&type=style&index=0&id=2de1f01e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de1f01e",
  null
  
)

export default component.exports